import { ModelTimelineSimple } from './model-timeline-simple';

export class SchedulerTaskSubTaskSimple {
  public formatedModelTimeLines: any;

  constructor(
    public hash?: string,
    public identifier?: number,
    public current?: boolean,
    public sent?: boolean,
    public sendDate?: number,
    public programsDuration?: number,
    public running?: boolean,
    public modelTimeLines?: ModelTimelineSimple[]
  ) { }

}



// WEBPACK FOOTER //
// /var/www/borneo/prod/borneo_app/src/app/core/models/scheduler-task-subtask-simple.ts